<!-- 资源分类编辑弹窗 -->
<template>
  <el-dialog :title="isUpdate ? '修改通道' : '添加通道'" :visible="visible" width="750px"
    :destroy-on-close="true" :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="类型分类" prop="channel_type_id">
            <el-select clearable class="ele-block" v-model="form.channel_type_id" placeholder="请选择">
              <el-option v-for="item in channeltypeList" :key="item.id" :value="item.id" :label="item.channel_name" />
            </el-select>
          </el-form-item>

          <el-form-item label="通道名称" prop="up_channel_name">
            <el-input clearable :maxlength="20" v-model="form.up_channel_name" placeholder="请输入" />
          </el-form-item>

        </el-col>
        <el-col :sm="12">
          <el-form-item label="小组名称">
            <el-select clearable class="ele-block" v-model="form.resource_class_id" placeholder="请选择">
              <el-option v-if="form.resource_class_id === 0" :key="0" :value="0" label="请选择" />
              <el-option v-for="item in classList" :key="item.id" :value="item.id" :label="item.classname" />
            </el-select>
          </el-form-item>
          <el-form-item label="控制器名">
            <el-input clearable :maxlength="20" v-model="form.code_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="金额规则" prop="money_gz">
            <el-input clearable :maxlength="20" v-model="form.money_gz" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ColumnEdit',
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 修改回显的数据
    data: Object
  },
  data() {
    return {
      // 表单数据
      form: Object.assign({ status: 1 }, this.data),
      // 表单验证规则
      rules: {
        channel_type_id: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        up_channel_name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        money_gz: [
          { required: true, message: '英文,号分割为区间 |分割为固定', trigger: 'blur' }
        ],

      },
      // 提交状态
      loading: false,
      // 是否是修改
      isUpdate: false,
      // 渠道分类列表
      channeltypeList: [],
      // 资源分类
      classList: [],
    };
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({}, this.data);

        this.isUpdate = true;
      } else {
        this.form = {};

        this.isUpdate = false;
      }
    }
  },
  mounted() {
    this.queryChannelType();  // 渠道分类列表
    this.queryClass();  // 资源分类列表
  },
  methods: {
    /* 保存编辑 */
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http.post('/channelcolumn/edit', this.form).then(res => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              if (!this.isUpdate) {
                this.form = {};
              }
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    /* 渠道分类列表 */
    queryChannelType() {
      this.$http.get('/Channeltype/getchannelTypeList').then(res => {
        if (res.data.code === 0) {
          this.channeltypeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /* 资源分类列表 */
    queryClass() {
      this.$http.get('/Resourceclass/getClassList').then(res => {
        if (res.data.code === 0) {
          this.classList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    }
  }
}
</script>

<style scoped></style>
